
<app-edit-menu />
<h1>My Account</h1>
@defer (when currentUser) {
    <div class="flex gap-4 justify-evenly no-tracking">
        <div class="w-full">
            <h2>Personal Information</h2>
            <div class="flex gap-2 mb-3">
                <div class="flex flex-col gap-2 w-full">
                    <label for="username">Username</label>
                    <input class="no-tracking" id="username" aria-describedby="username-help" [(ngModel)]="currentUser!.firstname" />
                </div>
                <div class="flex flex-col gap-2 w-full">
                    <label for="surname">Surname</label>
                    <input id="surname" class="no-tracking" aria-describedby="username-help" [(ngModel)]="currentUser!.surname" />
                </div>
            </div>
            <div class="flex flex-col gap-2 mb-3">
                <label for="username">Email Address</label>
                <input type="email" id="username" aria-describedby="username-help" [(ngModel)]="currentUser!.email" />
            </div>
            <div class="flex gap-2 mb-5 pb-5 border-b-4">
                <div class="flex flex-col gap-2 w-full">
                    <label for="dob">Date of Birth</label>
                    <input type="date" id="dob"  [ngModel]="currentUser!.dob | date:'yyyy-MM-dd'" (ngModelChange)="currentUser!.dob = $event">
                </div>
                <div class="flex flex-col align-middle items-center mt-3 justify-center gap-2 w-full">
                    <div>
                        <label class="switch me-4">
                            <input type="checkbox" id="displayBookings" [(ngModel)]="currentUser!.dob">
                            <span class="slider round"></span>
                          </label>
                        <label for="displayBookings">Display Bookings</label>
                    </div>
                    <small>Display your name on event booking lists</small>
                </div>
            </div>
            <p class="text-sm mb-5 ">The following information is not required to book an event, however in the event of an accident or emergency this information may aid us in getting you the appropriate assistance as quickly as possible.</p>
            <div class="flex flex-col gap-2 w-full mb-3">
                <label for="emergencyContactName">Emgergency Contact Name</label>
                <input id="emergencyContactName" aria-describedby="username-help" [(ngModel)]="currentUser!.emergencyContactName" />
            </div>
            <div class="flex gap-2 mb-3">
                <div class="flex flex-col gap-2 w-full">
                    <label for="surname">Emergency Contact Number</label>
                    <input id="surname" aria-describedby="username-help" [(ngModel)]="currentUser!.emergencyContactNumber" />
                </div>
                <div class="flex flex-col gap-2 w-full">
                    <label for="surname">Emergency Contact Relation</label>
                    <input id="surname" aria-describedby="username-help" [(ngModel)]="currentUser!.emergencyContactRelation" />
                </div>
            </div>
            <div class="flex flex-col gap-2 w-full mb-3">
                <label for="surname">Medical Notes</label>
                <textarea rows="2" cols="30" [(ngModel)]="currentUser!.medicalInfo"></textarea>
                <p class="text-xs">Do you have any medical conditions that may be relevant to, or the cause of, any emergency situations? This information will only be shared with First Aid teams should an issue arise.</p>
            </div>
            <div class="flex flex-col gap-2 w-full mb-3">
                <label for="surname">Food Allergy/Dietary Notes</label>
                <textarea rows="2" cols="30" [(ngModel)]="currentUser!.allergyDietary"></textarea>
                <p class="text-xs">Do you have any food allergies, or other dietary requirements? This information will be shared with event caterers should you book a meal ticket for your events.</p>
            </div>
        </div>
        <div class="w-full">
            <h2>LRP Event Systems</h2>
            <p-accordion class="w-full">
                @if (eventSystems$ | async; as eventSystems){
                @for (eventSystem of eventSystems; track $index) {
                    <p-accordion-panel [value]="$index">
                        <p-accordion-header>
                            <span class="flex align-items-center gap-2 w-full">
                                @if (eventSystem.img){
                                    <img [src]="eventSystem.img.url" class=" max-h-12" [alt]="eventSystem.name">
                                }
                                @else {
                                    {{ eventSystem.name }}
                                }
                            </span>
                        </p-accordion-header>
                        <p-accordion-content>
                            <div class="border-b-4 pb-3 mb-3">
                                <h2>Marketting Preferences</h2>
                                <input type="checkbox" [id]="eventSystem.systemRef + 'marketting'">
                                <label class="text-sm ms-2 pt-2" [for]="eventSystem.systemRef + 'marketting'">Please notify me by e-mail when {{eventSystem.name}} has new events available.</label>
                                <p class="text-xs mt-2">{{eventSystem.name}} will not gain access to your e-mail address, or be able to contact you directly by requesting marketting e-mails. All event adverts will be sent directly by LRPTickets.co.uk</p>
                            </div>
                            <div class="flex gap-4 justify-evenly w-full">
                                <div class="w-full">
                                    <h2>Character Details</h2>
                                    @for (customField of eventSystem.customFields; track customField.id){
                                        @if (customField.section === 'character') {
                                            <div class="mb-3 flex flex-col">
                                            @if (customField.type === 'number'){
                                                <label [for]="eventSystem.systemRef + '_' + customField.name">{{customField.label}}</label>
                                                <input type="number" [id]="eventSystem.systemRef + '_' + customField.name" [placeholder]="customField.placeholder" [value]="selectCustomField(customField.customFieldID)?.value" (change)="updateCustomField(customField.customFieldID,$event)">
                                            }
                                            @if (customField.type === 'text'){
                                                <label [for]="eventSystem.systemRef + '_' + customField.name">{{customField.label}}</label>
                                                <input [id]="eventSystem.systemRef + '_' + customField.name" [placeholder]="customField.placeholder ?? ''" [value]="selectCustomField(customField.customFieldID)?.value" (change)="updateCustomField(customField.customFieldID,$event)"/>
                                            }
                                            @if (customField.type === 'checkbox'){
                                                <div class="flex gap-4 mb-3">
                                                    <input type="checkbox" [id]="eventSystem.systemRef + '_' + customField.name" [value]="selectCustomField(customField.customFieldID)?.value" (click)="updateCustomField(customField.customFieldID,$event)">
                                                    <label [for]="eventSystem.systemRef + '_' + customField.name" (click)="updateCustomField(customField.customFieldID,$event)">{{customField.label}}</label>
                                                </div>
                                            }
                                            @if (customField.type === 'select'){
                                                <label [for]="eventSystem.systemRef + '_' + customField.name">{{customField.label}}</label>
                                                <select name="" id="" (change)="updateCustomField(customField.customFieldID,$event)">
                                                    @for (option of customField.customFieldsOptions; track option.id){
                                                        <option [value]="option.fieldOption" [selected]="selectCustomField(customField.customFieldID)?.value === option.fieldOption">{{ option.fieldOption}}</option>
                                                    }
                                                </select>
                                            }
                                            </div>
                                        }
                                    }
                                </div>
                                <div class="flex flex-col w-full">
                                    <h2>Player Details</h2>
                                    @for (customField of eventSystem.customFields; track customField.id){
                                        @if (customField.section === 'player' && customField.name != 'marketing') {
                                            <div class="mb-3 flex flex-col">
                                                @if (customField.type === 'number'){
                                                    <label [for]="eventSystem.systemRef + '_' + customField.name">{{customField.label}}</label>
                                                    <input type="number" [id]="eventSystem.systemRef + '_' + customField.name" [placeholder]="customField.placeholder" (change)="updateCustomField(customField.customFieldID,$event)" [value]="selectCustomField(customField.customFieldID)?.value">
                                                }
                                                @if (customField.type === 'text'){
                                                    <label [for]="eventSystem.systemRef + '_' + customField.name">{{customField.label}}</label>
                                                    <input [id]="eventSystem.systemRef + '_' + customField.name" [placeholder]="customField.placeholder ?? ''" (change)="updateCustomField(customField.customFieldID,$event)" [value]="selectCustomField(customField.customFieldID)?.value"/>
                                                }
                                                @if (customField.type === 'checkbox'){
                                                    <div class="flex gap-4 mb-3">
                                                        <label [for]="eventSystem.systemRef + '_' + customField.name" (change)="updateCustomField(customField.id,$event)">
                                                            <input type="checkbox" [id]="eventSystem.systemRef + '_' + customField.name" (click)="updateCustomField(customField.customFieldID,$event)" [value]="selectCustomField(customField.customFieldID)?.value">
                                                            {{customField.label}}
                                                        </label>
                                                    </div>
                                                }
                                                @if (customField.type === 'select'){
                                                    <label [for]="eventSystem.systemRef + '_' + customField.name">{{customField.label}}</label>
                                                    <select name="" id="" (change)="updateCustomField(customField.customFieldID,$event)">
                                                        @for (option of customField.customFieldsOptions; track option.id){
                                                            <option [value]="option.fieldOption" [selected]="selectCustomField(customField.customFieldID)?.value === option.fieldOption">{{ option.fieldOption}}</option>
                                                        }
                                                    </select>
                                                }
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                        </p-accordion-content>
                    </p-accordion-panel>
                }
            }
            </p-accordion>
        </div>
    </div>
    <div class="flex justify-end gap-3">
        <button class="outline-button w-32">Cancel</button>
        <button class="primaryButton w-32" (click)="updateUser()">Save</button>
    </div>
}